import React from "react";
import FlightInfoLine from './components/FlightInfoSquareLine/FlightInfoLine';
import {If, Then} from "react-if";
import FlightIcon from '@material-ui/icons/Flight';
import SquareIcon
  from 'gui/components/listPage/components/ad/components/squareIcon/SquareIcon';
import {IProduct} from 'data/interfaces/products';

export interface IFlightInfoSquare {
  className?: string;
  product: IProduct;
  style: any;
  showIcon: boolean;
  flip: boolean;
}

const FlightInfoSquare = (props: IFlightInfoSquare) => {
  return (
    <span
      className={props.className}
      style={{
        width: 145,
        height: 140,
        backgroundColor: "#f5f5f5",
        display: "table",
        ...props.style
      }}
    >
    <SquareIcon
      icon={FlightIcon}
      toolTip="טיסה"
      showIcon={props.showIcon}
    />
    <If condition={props.showIcon}>
      <Then>
          <div
            style={{
              marginTop: 52
            }}
          />
      </Then>
    </If>

    <FlightInfoLine timeOfTakeOff={props.product.ticketDetails.originTimeOfTakeOff}
                    timeOfLanding={props.product.ticketDetails.originTimeOfLanding}
                    originAirport={props.product.ticketDetails.originAirport}
                    destinationAirport={props.product.ticketDetails.destinationAirport}
                    flip={props.flip}
    />
    <If
      condition={!!(props.product.ticketDetails.isRoundTripTicket && props.product.ticketDetails.destinationTimeOfTakeOff && props.product.ticketDetails.destinationTimeOfLanding)}>
      <Then>
        {() => (
          <>
            <If condition={props.showIcon}>
              <Then>
                <div
                  style={{
                    marginTop: 20
                  }}
                />
              </Then>
            </If>
            <FlightInfoLine timeOfTakeOff={props.product.ticketDetails.destinationTimeOfTakeOff}
                            timeOfLanding={props.product.ticketDetails.destinationTimeOfLanding}
                            originAirport={props.product.ticketDetails.destinationAirport}
                            destinationAirport={props.product.ticketDetails.originAirport}
                            flip={props.flip}
            />
          </>
        )}
      </Then>
    </If>
  </span>
  );
}

FlightInfoSquare.defaultProps = {
  showIcon: true,
  style: {},
  flip: true,
};

export default FlightInfoSquare;
